import TitleHeader from './TitleHeader.component';

export default TitleHeader;
